import React from 'react';
import { Button } from '@fluentui/react-components';
import { WeatherMoon24Regular, WeatherSunny24Regular } from '@fluentui/react-icons';
import { useDarkMode } from '../contexts/DarkModeContext';

const DarkModeToggle: React.FC = () => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <Button
      appearance="subtle"
      icon={isDarkMode ? <WeatherSunny24Regular /> : <WeatherMoon24Regular />}
      onClick={toggleDarkMode}
      aria-label="Toggle dark mode"
      style={{
        position: 'fixed',
        top: '1rem',
        right: '1.5rem', // Increased from 1rem to avoid scrollbar overlap
        zIndex: 1000,
      }}
    />
  );
};

export default DarkModeToggle;

